/**
 * Policies page - Main listing page
 */
import React from 'react';
import { Link } from 'react-router-dom';

function Policies() {
  const policies = {
    core: [
      {
        id: 'terms',
        title: 'Terms of Service',
        description: 'Your agreement with HotBump',
        path: '/web/policies/terms'
      },
      {
        id: 'privacy',
        title: 'Privacy Policy',
        description: 'How we handle your personal information',
        path: '/web/policies/privacy'
      },
      {
        id: 'refund',
        title: 'Refund Policy',
        description: 'Subscription and payment refund terms',
        path: '/web/policies/refund'
      }
    ],
    content: [
      {
        id: 'prohibited',
        title: 'Prohibited Content Policy',
        description: 'Content that is not allowed on our platform',
        path: '/web/policies/prohibited'
      },
      {
        id: 'removal',
        title: 'Content Removal Policy',
        description: 'How and when content may be removed',
        path: '/web/policies/removal'
      },
      {
        id: 'moderation',
        title: 'Content Moderation Policy',
        description: 'Our approach to moderating platform content',
        path: '/web/policies/moderation'
      },
      {
        id: 'screening',
        title: 'Pre-Screening and Post-Screening Policy',
        description: 'Content review processes and procedures',
        path: '/web/policies/screening'
      }
    ],
    legal: [
      {
        id: 'complaint',
        title: 'Complaint Policy',
        description: 'How to file complaints and our response process',
        path: '/web/policies/complaint'
      },
      {
        id: '2257',
        title: '18 U.S.C 2257 Exemption',
        description: 'Federal record-keeping exemption notice',
        path: '/web/policies/2257'
      },
      {
        id: 'underage',
        title: 'Underage Policy',
        description: 'Strict policies regarding minors',
        path: '/web/policies/underage'
      },
      {
        id: 'aml',
        title: 'AML/Anti-Fraud Policy',
        description: 'Anti-money laundering and fraud prevention',
        path: '/web/policies/aml'
      },
      {
        id: 'trafficking',
        title: 'Sex Trafficking Policy',
        description: 'Zero-tolerance trafficking prevention policy',
        path: '/web/policies/trafficking'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-dark-900 to-burgundy-900 text-white py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold mb-8">Policies</h1>

        {/* Core Policies */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4 text-burgundy-400">Core Policies</h2>
          <div className="space-y-3">
            {policies.core.map((policy) => (
              <Link
                key={policy.id}
                to={policy.path}
                className="block bg-dark-800 border border-burgundy-800 rounded-lg p-4 hover:bg-dark-700 transition"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className="text-lg font-medium mb-1">{policy.title}</h3>
                    <p className="text-sm text-gray-400">{policy.description}</p>
                  </div>
                  <button className="ml-4 px-4 py-2 bg-burgundy-600 hover:bg-burgundy-700 rounded text-sm font-medium transition">
                    Read
                  </button>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Content Policies */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4 text-burgundy-400">Content Policies</h2>
          <div className="space-y-3">
            {policies.content.map((policy) => (
              <Link
                key={policy.id}
                to={policy.path}
                className="block bg-dark-800 border border-burgundy-800 rounded-lg p-4 hover:bg-dark-700 transition"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className="text-lg font-medium mb-1">{policy.title}</h3>
                    <p className="text-sm text-gray-400">{policy.description}</p>
                  </div>
                  <button className="ml-4 px-4 py-2 bg-burgundy-600 hover:bg-burgundy-700 rounded text-sm font-medium transition">
                    Read
                  </button>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Legal & Compliance */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4 text-burgundy-400">Legal & Compliance</h2>
          <div className="space-y-3">
            {policies.legal.map((policy) => (
              <Link
                key={policy.id}
                to={policy.path}
                className="block bg-dark-800 border border-burgundy-800 rounded-lg p-4 hover:bg-dark-700 transition"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className="text-lg font-medium mb-1">{policy.title}</h3>
                    <p className="text-sm text-gray-400">{policy.description}</p>
                  </div>
                  <button className="ml-4 px-4 py-2 bg-burgundy-600 hover:bg-burgundy-700 rounded text-sm font-medium transition">
                    Read
                  </button>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Need Help */}
        <section>
          <h2 className="text-2xl font-semibold mb-4 text-burgundy-400">Need Help?</h2>
          <div className="bg-dark-800 border border-burgundy-800 rounded-lg p-4">
            <h3 className="text-lg font-medium mb-1">Email Support</h3>
            <p className="text-sm text-gray-400 mb-2">We typically respond within 24 hours</p>
            <a
              href="mailto:support@hotbump.online"
              className="text-burgundy-400 hover:text-burgundy-300 text-sm"
            >
              support@hotbump.online
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Policies;



